import classNames from 'classnames';
import { FC, RefObject } from 'react';

import styles from './BackgroundPanelVideo.styles.m.css';

export interface IBackgroundPanelVideoProps {
  className?: string;
  videoRef: RefObject<HTMLDivElement>;
}

export const BackgroundPanelVideo: FC<IBackgroundPanelVideoProps> = ({ className, videoRef }) => {
  return (
    <div
      className={classNames(styles.container, className)}
      ref={videoRef}
    />
  );
};
